import { render, staticRenderFns } from "./bsp-dicts-checkbo.vue?vue&type=template&id=74643874&scoped=true&"
import script from "./bsp-dicts-checkbo.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-checkbo.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-checkbo.vue?vue&type=style&index=0&id=74643874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74643874",
  null
  
)

export default component.exports